import ManagerBaseDashboard from '../views/ManagerBase/ManagerBaseDashboard';
import ManagerBaseSettings from '../views/ManagerBase/ManagerBaseSettings';

import ManagerBasePipelines from '../views/ManagerBase/ManagerBasePipelines';
import ManagerBaseCandidates from '../views/ManagerBase/ManagerBaseCandidates';

import ManagerBaseJobs from '../views/ManagerBase/ManagerBaseJobs';
import ManagerJobItem from '../components/Manager/Jobs/ManagerJobItem';

// import AdminBaseEmployers from '../views/AdminBase/AdminBaseEmployers';
import AdminBaseReviewJobs from '../views/AdminBase/AdminBaseReviewJobs';
import AdminBaseReviewApplications from '../views/AdminBase/AdminBaseReviewApplications';

import UserManagment from '../components/Manager/ManagerUserManagment';

import ManagerCandidateItem from '../components/Manager/Candidates/ManagerCandidateItem.vue';

// import EmployersItem from '../components/Admin/Employers/EmployersItem';
// import JobItem from '@/components/Admin/Jobs/JobItem';

import ManagerBaseProfile from '../views/ManagerBase/ManagerBaseProfile.vue';
import EmptyRouterView from '../router/EmptyRouterView';
import SupportBase from '../views/SupportBase';
const url_prefix = process.env.VUE_APP_URL_PREFIX;

export default [
  {
    path: '/manager',
    name: 'manager',
    redirect: '/manager/dashboard',
    meta: {
      requiresAuth: true,
      managerAuth: true,
    },
  },
  {
    path: '/manager/profile',
    name: 'manager-profile',
    component: ManagerBaseProfile,
    meta: {
      requiresAuth: true,
      managerAuth: true,
    },
  },
  {
    path: '/manager/settings',
    name: 'manager-settings',
    component: ManagerBaseSettings,
    meta: { adminAuth: false, requiresAuth: true, managerAuth: true },
  },
  {
    path: '/manager/user-managment',
    name: 'manager-user-managment',
    component: UserManagment,
    meta: {
      requiresAuth: true,
      managerAuth: true,
    },
  },
  {
    path: '/manager/dashboard',
    name: 'manager-dashboard',
    component: ManagerBaseDashboard,
    meta: {
      requiresAuth: true,
      managerAuth: true,
      breadcrumb: 'Dashboard',
    },
  },
  {
    path: '/manager/pipelines',
    name: 'manager-pipelines',
    component: ManagerBasePipelines,
    meta: {
      requiresAuth: true,
      managerAuth: true,

      breadcrumb: function() {
        //const { name } = this.$route;
        return 'Pipelines';
      },
    },
  },
  // MANAGER/Candidates
  {
    path: '/manager',
    component: EmptyRouterView,
    meta: {
      requiresAuth: true,
      managerAuth: true,
    },
    children: [
      {
        path: '/manager/candidates',
        name: 'manager-candidates',
        component: ManagerBaseCandidates,
        meta: {
          requiresAuth: true,
          managerAuth: true,

          breadcrumb: 'Candidates',
        },
      },
      {
        path: '/manager/candidates',
        name: '',
        component: EmptyRouterView,
        meta: {
          requiresAuth: true,
          managerAuth: true,
          breadcrumb: '',
        },
        children: [
          {
            path: '/manager/candidates/:manager_candidate_id',
            name: 'manager_candidate_id',
            component: ManagerCandidateItem,
            meta: {
              requiresAuth: true,
              managerAuth: true,

              breadcrumb: function() {
                return `${this.$store.getters.getCandidateById.first_name} ${this.$store.getters.getCandidateById.last_name}`;
              },
            },
          },
        ],
      },
    ],
  },
  // MANAGER/Jobs
  {
    path: '/manager',
    component: EmptyRouterView,
    meta: {
      requiresAuth: true,
      managerAuth: true,
      userAuth: true,
    },
    children: [
      {
        path: '/manager/jobs',
        name: 'manager-jobs',
        component: ManagerBaseJobs,

        meta: {
          requiresAuth: true,
          managerAuth: true,
          userAuth: true,
          breadcrumb: 'Jobs',
        },
      },
      {
        path: '/manager/jobs',
        name: '',
        component: EmptyRouterView,
        meta: {
          requiresAuth: true,
          managerAuth: true,
          userAuth: false,
          breadcrumb: '',
        },
        children: [
          {
            path: '/manager/jobs/:manager_job_uuid',
            name: 'manager_job_uuid',
            component: ManagerJobItem,
            meta: {
              requiresAuth: true,
              managerAuth: true,
              userAuth: false,
              breadcrumb: function() {
                return '';
                // return this.$store.getters.getJobAdById.title;
              },
            },
          },
        ],
      },
    ],
  },

  {
    path: '/manager/support',
    name: 'manager-support',
    component: SupportBase,
    meta: {
      requiresAuth: true,
      managerAuth: true,
      userAuth: true,
      breadcrumb: function() {
        return 'Support';
      },
    },
  },

  // Manager Review
  {
    path: '/manager/review/jobs',
    name: 'manager-review-jobs',
    component: AdminBaseReviewJobs,
    meta: {
      requiresAuth: true,
      managerAuth: true,
      userAuth: true,
      breadcrumb: function() {
        return 'Review / Jobs';
      },
    },
  },
  {
    path: '/manager/review/applications',
    name: 'manager-review-applications',
    component: AdminBaseReviewApplications,
    meta: {
      requiresAuth: true,
      managerAuth: true,
      userAuth: true,
      breadcrumb: function() {
        return 'Review / Applications';
      },
    },
  },
];
